<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

const goBack = () => {
  router.push('/');
};

const disclosureData = {
  completeName: "VIVEK GUPTA",
  registrationType: "Individual",
  iaCategory: "Investment Adviser (IA)",
  registrationNumber: "INA000020554",
  registrationValidity: "Jul 11, 2025 – Perpetual",
  email: "vivek203@yahoo.com",
  telephone: "+91 9958836060",
  fax: "+91 9958836060",
  registeredAddress: "Flat No-65, RPS, Sheikh Sarai Phase I, New Delhi, National Capital Territory of Delhi, 110017",
  correspondenceAddress: "Flat No-65, RPS, Sheikh Sarai Phase I, New Delhi, National Capital Territory of Delhi, 110017",
  principalOfficerName: "Vivek Gupta",
  principalOfficerEmail: "vivek203@yahoo.com",
  principalOfficerPhone: "+91 9958836060",
  sebiLocalOfficeName: "SEBI Northern Regional Office (NRO)",
  sebiLocalOfficeAddress: "NBCC Complex, Office Tower-1, 8th Floor, Plate B, East Kidwai Nagar, New Delhi – 110023",
  sebiLocalOfficeTelephone: "+91-011-69012998",
  sebiLocalOfficeEmail: "sebinro@sebi.gov.in"
};
</script>

<template>
  <div class="sebi-disclosures-page">
    <!-- Header Section -->
    <div class="disclosure-header">
      <div class="header-container">
        <button class="back-btn" @click="goBack">
          <i class="pi pi-arrow-left"></i> Back to Home
        </button>
        <h1 class="main-title">Regulatory Disclosures</h1>
        <p class="subtitle">SEBI Registered Investment Adviser</p>
        <div class="reg-number">Reg. No: {{ disclosureData.registrationNumber }}</div>
      </div>
    </div>

    <!-- Disclaimer Section -->
    <div class="disclaimer-section">
      <div class="disclaimer-box">
        <i class="pi pi-info-circle"></i>
        <p>Registration granted by SEBI, and the certificate of registration, does not in any manner guarantee performance of the intermediary or provide any assurance of returns to investors.</p>
      </div>
    </div>

    <!-- Main Content -->
    <div class="disclosure-content">
      <!-- Registration Details -->
      <section class="disclosure-section">
        <h2 class="section-title">
          <i class="pi pi-id-card"></i>
          Registration Details
        </h2>
        <div class="info-grid">
          <div class="info-item">
            <label>Complete Name of Investment Adviser</label>
            <div class="info-value">{{ disclosureData.completeName }}</div>
          </div>
          <div class="info-item">
            <label>Type of Registration</label>
            <div class="info-value">{{ disclosureData.registrationType }}</div>
          </div>
          <div class="info-item">
            <label>Category</label>
            <div class="info-value">{{ disclosureData.iaCategory }}</div>
          </div>
          <div class="info-item">
            <label>Registration Number</label>
            <div class="info-value highlight">{{ disclosureData.registrationNumber }}</div>
          </div>
          <div class="info-item full-width">
            <label>Validity of Registration</label>
            <div class="info-value">{{ disclosureData.registrationValidity }}</div>
          </div>
        </div>
      </section>

      <!-- Contact Information -->
      <section class="disclosure-section">
        <h2 class="section-title">
          <i class="pi pi-phone"></i>
          Contact Information
        </h2>
        <div class="info-grid">
          <div class="info-item full-width">
            <label>Registered Address</label>
            <div class="info-value">{{ disclosureData.registeredAddress }}</div>
          </div>
          <div class="info-item full-width">
            <label>Correspondence Address</label>
            <div class="info-value">{{ disclosureData.correspondenceAddress }}</div>
          </div>
          <div class="info-item">
            <label>Telephone</label>
            <div class="info-value">
              <a :href="`tel:${disclosureData.telephone}`">{{ disclosureData.telephone }}</a>
            </div>
          </div>
          <div class="info-item">
            <label>Fax</label>
            <div class="info-value">{{ disclosureData.fax }}</div>
          </div>
          <div class="info-item full-width">
            <label>Email</label>
            <div class="info-value">
              <a :href="`mailto:${disclosureData.email}`">{{ disclosureData.email }}</a>
            </div>
          </div>
        </div>
      </section>

      <!-- Principal Officer Details -->
      <section class="disclosure-section">
        <h2 class="section-title">
          <i class="pi pi-user"></i>
          Principal Officer Details
        </h2>
        <div class="info-grid">
          <div class="info-item">
            <label>Name</label>
            <div class="info-value">{{ disclosureData.principalOfficerName }}</div>
          </div>
          <div class="info-item">
            <label>Contact Number</label>
            <div class="info-value">
              <a :href="`tel:${disclosureData.principalOfficerPhone}`">{{ disclosureData.principalOfficerPhone }}</a>
            </div>
          </div>
          <div class="info-item full-width">
            <label>Email</label>
            <div class="info-value">
              <a :href="`mailto:${disclosureData.principalOfficerEmail}`">{{ disclosureData.principalOfficerEmail }}</a>
            </div>
          </div>
        </div>
      </section>

      <!-- SEBI Regional Office -->
      <section class="disclosure-section">
        <h2 class="section-title">
          <i class="pi pi-building"></i>
          Corresponding SEBI Regional Office
        </h2>
        <div class="info-grid">
          <div class="info-item full-width">
            <label>Office Name</label>
            <div class="info-value">{{ disclosureData.sebiLocalOfficeName }}</div>
          </div>
          <div class="info-item full-width">
            <label>Address</label>
            <div class="info-value">{{ disclosureData.sebiLocalOfficeAddress }}</div>
          </div>
          <div class="info-item">
            <label>Telephone</label>
            <div class="info-value">
              <a :href="`tel:${disclosureData.sebiLocalOfficeTelephone}`">{{ disclosureData.sebiLocalOfficeTelephone }}</a>
            </div>
          </div>
          <div class="info-item">
            <label>Email</label>
            <div class="info-value">
              <a :href="`mailto:${disclosureData.sebiLocalOfficeEmail}`">{{ disclosureData.sebiLocalOfficeEmail }}</a>
            </div>
          </div>
        </div>
      </section>

      <!-- Contact & Grievance Redressal -->
      <section class="disclosure-section grievance-section">
        <h2 class="section-title">
          <i class="pi pi-comments"></i>
          Contact & Grievance Redressal
        </h2>
        <div class="grievance-content">
          <p class="grievance-text">
            For any queries, clarifications, or grievances related to investment advisory services, clients may contact the Principal Officer:
          </p>

          <div class="contact-box">
            <div class="contact-item">
              <strong>Principal Officer:</strong> {{ disclosureData.principalOfficerName }}
            </div>
            <div class="contact-item">
              <strong>Email:</strong>
              <a :href="`mailto:${disclosureData.principalOfficerEmail}`">{{ disclosureData.principalOfficerEmail }}</a>
            </div>
            <div class="contact-item">
              <strong>Phone:</strong>
              <a :href="`tel:${disclosureData.principalOfficerPhone}`">{{ disclosureData.principalOfficerPhone }}</a>
            </div>
          </div>

          <p class="grievance-text">
            Clients are encouraged to first reach out to the Investment Adviser for resolution of any concerns.
            If the grievance is not resolved satisfactorily, clients may escalate the matter through
            <a href="https://scores.sebi.gov.in/" target="_blank" rel="noopener noreferrer">SEBI's SCORES platform</a>
            in accordance with SEBI guidelines.
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<style scoped>
.sebi-disclosures-page {
  min-height: 100vh;
  background: #f8fafc;
}

.disclosure-header {
  background: linear-gradient(135deg, #0e38d2 0%, #4fb6ed 100%);
  color: white;
  padding: 40px 20px;
  text-align: center;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

.back-btn {
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.2s ease;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.main-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 10px 0;
}

.subtitle {
  font-size: 1.2rem;
  margin: 0 0 10px 0;
  opacity: 0.95;
}

.reg-number {
  font-size: 1rem;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.2);
  display: inline-block;
  padding: 6px 16px;
  border-radius: 20px;
  margin-top: 10px;
}

.disclaimer-section {
  max-width: 1200px;
  margin: -20px auto 30px;
  padding: 0 20px;
}

.disclaimer-box {
  background: #fef3c7;
  border: 2px solid #fbbf24;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.disclaimer-box i {
  font-size: 1.5rem;
  color: #d97706;
  flex-shrink: 0;
  margin-top: 2px;
}

.disclaimer-box p {
  margin: 0;
  font-size: 0.95rem;
  color: #78350f;
  line-height: 1.6;
}

.disclosure-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.disclosure-section {
  background: white;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.section-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 25px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e5e7eb;
}

.section-title i {
  color: #3b82f6;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-item label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 1rem;
  color: #1f2937;
  padding: 12px;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.info-value.highlight {
  background: #eff6ff;
  border-color: #3b82f6;
  color: #1e40af;
  font-weight: 600;
}

.info-value a {
  color: #3b82f6;
  text-decoration: none;
}

.info-value a:hover {
  text-decoration: underline;
}

.grievance-section {
  background: #f0fdf4;
  border: 2px solid #86efac;
}

.grievance-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.grievance-text {
  font-size: 0.95rem;
  line-height: 1.7;
  color: #1f2937;
  margin: 0;
}

.grievance-text a {
  color: #3b82f6;
  font-weight: 600;
  text-decoration: none;
}

.grievance-text a:hover {
  text-decoration: underline;
}

.contact-box {
  background: white;
  border: 2px solid #d1fae5;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-item {
  font-size: 0.95rem;
  color: #1f2937;
}

.contact-item strong {
  color: #065f46;
  min-width: 140px;
  display: inline-block;
}

.contact-item a {
  color: #3b82f6;
  text-decoration: none;
}

.contact-item a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .main-title {
    font-size: 1.75rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .back-btn {
    position: static;
    margin-bottom: 20px;
    justify-content: center;
  }

  .disclosure-section {
    padding: 20px;
  }

  .section-title {
    font-size: 1.25rem;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .info-item.full-width {
    grid-column: 1;
  }
}
</style>
